/* eslint-disable vue/valid-v-slot */
<template>
  <div>
    <div class="pa-4 pa-md-2 breadcrum-wrapper">
      <Breadcrumbs
        v-if="classData"
        data="classData.title"
        :headline="classData.code"
        :link="[
          { text: 'Danh sách lớp', href: '../../../classes' },
          {
            text: classData.code,
            id: classData.id,
            href: `../../class/${classData.id}`
          },
          { text: 'Điểm Danh' }
        ]"
      />
    </div>
    <div class="card-container">
      <v-card class="mx-md-2 card">
        <v-skeleton-loader
          v-if="!slots"
          class="mx-auto"
          max-width="300"
          type="table-heading"
        ></v-skeleton-loader>
        <v-data-table
          v-else
          class="attendances"
          hide-default-header
          :headers="headers"
          :items="items"
          hide-default-footer
          :items-per-page="50"
          :dense="true"
          mobile-breakpoint=""
        >
          <template v-slot:body="{ items }">
            <class-attendance-dialog
              :state="attendanceDialogState"
              :slotData="selectedSlot"
              :classData="classData"
              :attendances="attendances"
            ></class-attendance-dialog>
            <tbody>
              <tr>
                <th
                  v-for="item in headers"
                  :key="item.text"
                  :style="{
                    background: '#fff',
                    'white-space': 'nowrap'
                  }"
                  :class="[item.value]"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-if="
                          item.slot &&
                          ['teacher', 'super_admin', 'education_manager'].includes(role.type)
                        "
                        v-on="on"
                        style="
                          cursor: pointer;
                          padding: 1px;
                          border-radius: 10%;
                          text-decoration: underline;
                          display: flex;
                          align-items: center;
                          flex-direction: column;
                        "
                        :style="[isValid(item) ? { color: 'black' } : { color: '#9e9e9e' }]"
                        @click="openAttendanceDialog(item)"
                      >
                        <span>{{ item.text }}</span>
                        <span style="">({{ item.startTime | familiarizeDate }})</span>
                      </div>
                      <p v-else style="margin: 0">
                        {{ item.text }}
                      </p>
                    </template>
                    <span>{{ headerTooltip(item) }}</span>
                  </v-tooltip>
                </th>
              </tr>
              <tr v-for="(item, index) in items" :key="item.code">
                <td style="width: 100px !important">
                  <div class="">
                    {{ index + 1 }}
                  </div>
                </td>
                <td>
                  <user-item
                    :size="$vuetify.breakpoint.mobile ? 24 : undefined"
                    :data="item.user"
                    :to="'../users/' + item.user.id"
                    >{{ item.user.status }}</user-item
                  >
                </td>
                <td style="white-space: nowrap">
                  <span class="absent-text">{{ item.absentPercentage + ' %' }}</span>
                  <v-icon
                    :small="$vuetify.breakpoint.smAndDown"
                    right
                    v-if="item.absentPercentage > 20"
                    color="warning"
                    >mdi-alert</v-icon
                  >
                </td>
                <td>
                  {{ item.user.tags }}
                </td>
                <td v-for="data in item.slots" :key="data.mergedId" style="text-align: center">
                  <v-btn
                    v-if="
                      requesting(`teacher_attendance_${data.mergedId}`) && role.name !== 'Student'
                    "
                    loading
                    small
                    icon
                  ></v-btn>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-icon style="" v-on="on" :color="getColor(data)">{{
                        data | getIcon(data)
                      }}</v-icon>
                    </template>
                    <span>{{ data | getTooltips(data) }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import UserItem from '@/modules/user/UserItem'
import ClassAttendanceDialog from '@/modules/class/attendance/ClassAttendanceDialog'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import { calculateAbsentPercentage } from '@/helpers'
export default {
  components: {
    UserItem,
    ClassAttendanceDialog,
    Breadcrumbs
  },

  data() {
    return {
      attendanceDialogState: false,
      selectedSlot: {},
      attendanceCheckTime: 24
    }
  },
  async created() {
    const classId = this.$route.params.id
    this.initClass({ id: classId })
  },
  mounted() {
    console.log(this.attendances)
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapGetters('rest', ['requesting']),
    ...mapGetters('classDetail', ['classData', 'slots', 'classList', 'attendances']),
    ...mapState('auth', ['user', 'role']),
    headers() {
      return [
        {
          text: 'STT',
          value: 'index',
          align: 'left',
          sortable: false
        },
        { text: 'Học sinh', value: 'user', align: 'left', sortable: false },
        {
          text: 'Nghỉ học',
          value: 'absent',
          align: 'left',
          sortable: false
        },
        { text: 'Nhóm lớp', value: 'user.tags', align: 'left', sortable: false },
        ...this.slots.map((slot, i) => {
          return {
            text: `Buổi ${i + 1}`,
            value: slot.code,
            align: 'left',
            sortable: false,
            hours: moment.duration(moment(slot.startTime).diff(moment())).asHours(),
            slot,
            startTime: slot.startTime
          }
        })
      ]
    },
    items() {
      const students = _.get(this.classData, `students`, [])
      return students.map(student => {
        const slots = this.slots.map(slot => {
          const attendance = _.get(this.attendances, `${slot.id + student.id}`, {})
          return {
            ...attendance,
            ...slot,
            mergedId: `${student.id}_${slot.id}`,
            hours: moment.duration(moment(slot.startTime).diff(moment())).asHours(),
            status: attendance.status,
            dataType: 'student-attendance'
          }
        })
        return {
          user: student,
          slots,
          absentPercentage: calculateAbsentPercentage(slots)
        }
      })
    }
  },
  methods: {
    ...mapActions('classDetail', ['fetchClass', 'updateClass', 'createAttendance', 'initClass']),
    getColor(slot) {
      if (slot.isFuture) return 'gray'
      if (slot.status === 'late') return 'yellow'
      if (slot.status === 'attendance') return 'green'
      if (slot.status === 'absent') return 'red'
      if (slot.status === 'late' || slot.status === 'approved-absent') {
        return 'orange'
      } else return 'red'
    },
    // absentPercentage(slots) {
    //   const absentSlots = slots.reduce(
    //     (acc, s) =>
    //       (acc +=
    //         s.status === 'absent'
    //           ? 1
    //           : s.status === 'approved-absent'
    //           ? 0.5
    //           : s.status === 'late'
    //           ? 0.33
    //           : 0),
    //     0
    //   )
    //   return Math.round((absentSlots * 10000) / slots.length) / 100
    // },
    takeAttendance(student, data) {
      this.createAttendance({
        data: {
          slot: data.id,
          slotType: data.type,
          student: student.id,
          date: data.startTime,
          duration: moment.duration(moment(data.endTime).diff(data.startTime)).asHours(),
          userId: student.id,
          class: this.classData.id,
          course: _.get(this.classData, 'course.id'),
          department: this.department.id,
          status: data.status,
          type: 'student-attendance'
        },
        option: {
          requestId: `teacher_attendance_${data.mergedId}`
        }
      })
    },
    isValid(item) {
      if (this.role.name === 'Teacher') {
        return item.hours < this.attendanceCheckTime && item.hours > -1 * this.attendanceCheckTime
      }
      return true
    },
    headerTooltip(item) {
      // if (this.role.name === 'Teacher') {
      if (!['super_admin', 'education_manager', 'teacher'].includes(this.role.type)) {
        return ''
      }
      if (item.hours < -1 * this.attendanceCheckTime) {
        return 'Đã quá hạn điểm danh'
      }
      if (item.hours > this.attendanceCheckTime) {
        return 'Chưa đến lúc điểm danh'
      }
      // }
      return 'Bấm vào để điểm danh'
    },
    openAttendanceDialog(item) {
      if (!['super_admin', 'education_manager', 'teacher'].includes(this.role.type)) {
        return
      }
      if (this.isValid(item)) {
        this.attendanceDialogState = !this.attendanceDialogState
        this.selectedSlot = item.slot
      }
    }
  },
  filters: {
    getIcon(data) {
      if (data.status === 'attendance' || data.status === 'late') {
        return 'mdi-check'
      } else if (data.status === 'absent' || data.status === 'approved-absent') {
        return 'mdi-close'
      }
      if (!data.status) return ''
      else return 'mdi-close'
    },
    getTooltips(slot) {
      if (slot.status === 'attendance') return 'Có mặt'
      if (slot.status === 'absent') return 'Nghỉ'
      if (slot.status === 'approved-absent') return 'Vắng có phép'
      if (slot.status === 'late') return 'Đi Muộn'
      else return 'Nghỉ'
    },
    familiarizeDate: time => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM HH:mm')
    }
  }
}
</script>
<style scoped lang="scss">
@import '~vuetify/src/styles/styles.sass';
::v-deep table {
  table-layout: fixed;
}
::v-deep .v-data-table__wrapper {
  overflow: unset !important;
  width: fit-content;
}

.attendances {
  font-size: 1em;
  max-width: fit-content;
  width: fit-content;
  --cell-width: 125px;
  --index-cell-width: 60px;
  --user-cell-width: 240px;
  --absent-cell-width: 100px;
  --absent-text-cell-width: 42px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .attendances {
    --cell-width: 100px;
    --index-cell-width: 40px;
    --user-cell-width: 140px;
    --absent-cell-width: 80px;
    --absent-text-cell-width: 36px;

    th,
    td {
      padding-left: 8px !important;
      padding-right: 8px !important;
      font-size: 0.75rem !important;
    }
  }
}
table th {
  width: var(--cell-width);
  &.user {
    width: var(--user-cell-width);
  }
  &.index {
    width: var(--index-cell-width);
  }
  &.absent {
    width: var(--absent-cell-width);
  }
}
.absent-text {
  width: var(--absent-text-cell-width);
  display: inline-block;
}

table > tbody > tr > th,
td {
  &:nth-child(1) {
    left: 0;
  }
  &:nth-child(2) {
    left: var(--index-cell-width);
  }
  &:nth-child(3) {
    left: calc(var(--index-cell-width) + var(--user-cell-width));
  }
}
table td:nth-child(3),
th:nth-child(3) {
  border-right: 1px solid #f1f1f1;
}

table > tbody > tr > td:nth-child(-n + 3),
th:nth-child(-n + 3) {
  position: sticky !important;
  position: -webkit-sticky !important;
  background: white;
}
table > tbody > tr > td:nth-child(-n + 3) {
  z-index: 3;
}
table > tbody > tr > th:nth-child(-n + 3) {
  z-index: 5;
}

table th {
  position: sticky !important;
  position: -webkit-sticky !important;
  z-index: 4;
  top: 0;
  background-color: #fff;
}
.breadcrum-wrapper {
  left: 8px;
  position: sticky;
  width: fit-content;
}
.card {
  width: fit-content;
}
.card-container {
  overflow-x: auto;
  max-height: calc(100vh - 150px);
}
</style>
